// ON SCROLL
window.addEventListener(
	"scroll",
	() => {
		if (window.scrollY > 0) {
			window.document.body.classList.add("scrolled");
		} else {
			window.document.body.classList.remove("scrolled");
		}
	},
	{ passive: true }
);
